import React from "react";

export default function Events() {
  const events = [
    {
      name: "Parish Feast of St. Stephen",
      date: "26 December 2025",
      details: "Holy Mass at 6:00 PM followed by fellowship dinner.",
    },
    {
      name: "Community Outreach Program",
      date: "15 November 2025",
      details: "Volunteers will visit nearby shelters to distribute food kits.",
    },
  ];

  return (
    <main className="pt-24 pb-16 px-6 max-w-5xl mx-auto text-gray-700">
      <h1 className="text-3xl font-bold text-center mb-8">Upcoming Events</h1>

      <div className="grid md:grid-cols-2 gap-6">
        {events.map((event, i) => (
          <div
            key={i}
            className="bg-white shadow-md rounded-lg p-5 border-t-4 border-amber-500"
          >
            <h2 className="font-semibold text-xl">{event.name}</h2>
            <p className="text-sm text-gray-500 mb-2">{event.date}</p>
            <p>{event.details}</p>
          </div>
        ))}
      </div>
    </main>
  );
}
